import React from 'react';
import { Form, Col } from 'react-bootstrap';

const FormikRadio = ({ label, options, margin, error, touched, helpText, abbr, field, form, ...props }) => (
  <Form.Group className={margin} as={Col}>
    {label ? (
      <Form.Label>
        <span style={{ fontSize: '0.81rem', fontWeight: 600 }}> {label} </span>{' '}
        {abbr ? <abbr className="text-danger">*</abbr> : false}
      </Form.Label>
    ) : (
      false
    )}
    <div
      className="form-control d-flex justify-content-around align-items-center"
      style={{
        height: 'auto',
        padding: '12px',
        border: error && touched ? '1px solid #dc3545' : '1px solid #ced4da',
        borderRadius: '4px'
      }}
    >
      {options.map(option => {
        const inputId = `${field.name}_${option.value}`;
        return (
          <div key={option.value} className="form-check">
            <label htmlFor={inputId} className="form-check-label">
              <input
                type="radio"
                id={inputId}
                name={field.name}
                value={option.value}
                checked={field.value === option.value}
                onChange={() => form.setFieldValue(field.name, option.value)}
                onBlur={field.onBlur}
                className="form-check-input"
                {...props}
              />
              {option.label}
            </label>
          </div>
        );
      })}
    </div>
    {error && touched ? <Form.Text className="text-danger ml-1">{error}</Form.Text> : null}
    {helpText ? <Form.Text className="text-muted">{helpText}</Form.Text> : null}
  </Form.Group>
);

export default FormikRadio;
